// Tour configuration for testing and development

import { TourSection } from '../components/walkthrough/tourSteps';

/**
 * TESTING FLAG: Set to true to always show tours regardless of completion status
 * This is useful for testing tour flows without creating new accounts
 * 
 * SET TO FALSE IN PRODUCTION!
 */
export const FORCE_SHOW_TOURS = false;

/**
 * TESTING: Specify which specific tours to show (leave empty array to show all)
 * Use tour section names like:
 * - 'lesson-general'
 * - 'lesson-voice'
 * - 'lesson-pdf-context'
 * - 'dashboard-no-subjects'
 * - 'dashboard-with-subjects'
 * - 'add-subject'
 * - 'child-no-subjects'
 * - 'child-with-subjects'
 * - 'parent-no-children'
 * - 'parent-with-children'
 * 
 * Examples:
 * - [] = Show all tours
 * - ['lesson-general'] = Only show lesson-general tour
 * - ['lesson-general', 'lesson-pdf-context'] = Show both lesson tours
 */
export const ENABLED_TOURS: TourSection[] = [];

/**
 * Check if a tour should be shown based on user profile and testing flag
 */
export const shouldShowTour = (
  tourCompleted: boolean, 
  tourEnabled: boolean = true,
  tourSection?: TourSection
): boolean => {
  if (FORCE_SHOW_TOURS) {
    // If specific tours are configured, only show those
    if (ENABLED_TOURS.length > 0 && tourSection) {
      return ENABLED_TOURS.includes(tourSection);
    }
    return true;
  }
  return tourEnabled && !tourCompleted;
};
